import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { IntercomPluginInterface } from './definitions';
import { CAPACITOR_INTERCOM_PLUGIN_NAME } from '../pluginConstants';

const IntercomPluginRaw = registerPlugin<IntercomPluginInterface>(CAPACITOR_INTERCOM_PLUGIN_NAME);
const IntercomPlugin = withBridgedStackTrace(IntercomPluginRaw, 'IntercomPlugin');

export * from './definitions';
export { IntercomPlugin };
